export const LIMIT = 20;
export const UPLOAD_CONST = "https://savethequest.org/uploads/upload.php";
